module.exports = __webpack_public_path__ + "img/genesis-drop-bubble-2-bg.4d576fc7.png";